<template>
  <div class="w-full">
    <el-form :model="form" :label-position="labelPosition" :rules="rules" ref="form">
      <OrderForm :form="form" />
      <el-form-item :gutter="20" class="px-5">
        <el-button type="primary" @click="submit('form')" :loading="adding">Save</el-button>
        <el-button @click="$router.back()" type="info">Cancel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import OrderForm from './_includes/OrderForm.vue';

export default {
  name: 'NewOrder',
  data() {
    return {
      adding: false,
      labelPosition: 'top',
      rules: this.$store.state.OrderModule.validate_form,
    };
  },
  components: {
    OrderForm,
  },
  computed: {
    form() {
      return this.$store.state.OrderModule.new_order;
    },
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
  methods: {
    submit(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          try {
            this.adding = true;
            await this.$store.dispatch('OrderModule/newOrder', { order: this.form });
            this.$notify.success({
              title: 'Success',
              message: 'Order successfully added',
            });
            await this.$router.push(`/ecommerce/orders/${
              this.$store.state.OrderModule.order.id
            }/details`);
          } catch (e) {
            this.adding = false;
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong',
            });
          }
          this.adding = false;
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
